<template>
  <v-card
    :loading="loading"
    class="mx-auto my-12"
    max-width="800"
  >
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <v-img
      height="250"
      src="https://i.ytimg.com/vi/12_VDwh25Qw/maxresdefault.jpg"
    ></v-img>

    <v-card-title>๑. จกฺขุปาลตฺเถรวตฺถุ.</v-card-title>

    <v-card-text>
      <v-row>
        <Paragraph
          v-for="para in paragraphs"
          :key="para.id"
          :story="para.story"
          :wak="para.wak"
          :pak="para.pak"
          :paragraph="para.paragraph"
          :thai="para.thai"/>
      </v-row>
    </v-card-text>
<!--     <v-card-actions>
      <v-btn
        color="deep-purple lighten-2"
        text
        @click="reserve"
      >
        Reserve
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>
<script>
import Paragraph from '@/components/Paragraph.vue'

export default {
  name: 'Story',
  components: {
    Paragraph
  },
  props: {
    title: String,
    pak: Number,
    wak: Number,
    story: Number
  },
  data: () => ({
    loading: false,
    hover1: false,
    hover2: false,
    paragraphs: []
  }),
  mounted: function () {
    console.log('pak:' + this.title)
    this.fetchParagraph(1, 1, 1)
  },
  methods: {
    reserve () {
      this.loading = true

      setTimeout(() => (this.loading = false), 2000)
    },
    fetchParagraph (pak, wak, story) {
      console.log(`https://sheet.best/api/sheets/433218c4-6b0a-41ce-9fab-280bebce3abf/tabs/db_paragraph/search?story=${story}&wak=${wak}&pak=${pak}`)
      fetch(`https://sheet.best/api/sheets/433218c4-6b0a-41ce-9fab-280bebce3abf/tabs/db_paragraph/search?story=${story}&wak=${wak}&pak=${pak}`)
        .then((response) => response.json())
        .then((data) => {
          console.log(data)
          this.paragraphs = data
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
